export const category = {
  crew: {
    category: [
      // {"key" : "all" , "value" : "all"},
      // { "key" : "uncommon" , "value" : "uncommon"},
      // { "key" : "common" , "value" : "common"},
      // { "key" : "rare" , "value" : "rare"},
      // { "key" : "legendary" , "value" : "legendary"}
    ],
    type: [
      { key: "male", value: "male" },
      { key: "female", value: "female" },
    ],
  },
  specialcrew: {
    category: [
      { key: "pilot", value: "pilot" },
      { key: "xenobiologist", value: "xenobiologist" },
      { key: "xenoanthropologist", value: "xenoanthropologist" },
      { key: "combat_specialist", value: "combat specialist" },
      { key: "explorer", value: "explorer" },
      { key: "mad_scientist", value: "mad scientist" },
      { key: "mech_pilot", value: "mech pilot" },
      { key: "capital_class_pilot", value: "capital class pilot" },
      { key: "governor", value: "governor" },
      { key: "foreman", value: "foreman" },
      { key: "engineer", value: "engineer" },
      { key: "miner", value: "miner" },
      { key: "astroengineer", value: "astroengineer" },
      { key: "megastructure_engineer", value: "megastructure engineer" },
      { key: "visionary", value: "visionary" },
      { key: "socialite", value: "socialite" },
      { key: "poet", value: "poet" },
      { key: "artist", value: "artist" },
      { key: "xenoarcheologist", value: "xenoarcheologist" },
      { key: "xenohistorian", value: "xenohistorian" },
      { key: "entrepreneur", value: "entrepreneur" },
      { key: "investor", value: "investor" },
      { key: "psychiatrist", value: "psychiatrist" },
      { key: "ship_gunner", value: "ship gunner" },
      { key: "ai_technician", value: "ai technician" },
      { key: "author", value: "author" },
      { key: "farmer", value: "farmer" },
      { key: "quantum_physicist", value: "quantum physicist" },
      { key: "sergeant_major", value: "sergeant major" },
    ],
    type: [
      { key: "male", value: "male" },
      { key: "female", value: "female" },
    ],
  },
  ship: {
    category: [
      // {
      //     "key" : "all","value" : "all"
      // },
      {
        key: "combat",
        value: "combat",
      },
      {
        key: "explore",
        value: "explore",
      },
      {
        key: "mine",
        value: "mine",
      },
      {
        key: "social",
        value: "social",
      },
    ],
  },
  planet: {
    category: [
      // {
      //     "key" : "all","value" : "all"
      // },
      {
        key: "uncommon",
        value: "un common",
      },
      {
        key: "common",
        value: "common",
      },
      {
        key: "rare",
        value: "rare",
      },
    ],
  },
  astroid: {
    category: [
      // {
      //     "key" : "all","value" : "all"
      // },
      {
        key: "uncommon",
        value: "un common",
      },
      {
        key: "common",
        value: "common",
      },
      {
        key: "rare",
        value: "rare",
      },
    ],
  },
};
